import React from 'react';
import { ReactComponent as SearchIcon } from '../../../assets/icons/search-sm.svg';
import { ReactComponent as ChevronIcon } from '../../../assets/icons/chevron-down.svg';
import { ReactComponent as FilterIcon } from '../../../assets/icons/filter-lines.svg';

import Select from "../../ReusableComponents/Select";
interface SearchFilterProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  selectedTags: string[];
  onTagToggle: (tag: string) => void;
  availableTags: string[];
  sortBy: string;
  onSortChange: (value: string) => void;
}

const SearchFilter: React.FC<SearchFilterProps> = ({
  searchValue,
  onSearchChange,
  selectedTags,
  onTagToggle,
  availableTags,
  sortBy,
  onSortChange
}) => {

  return (
    <div className="mb-6">
      <div className="flex items-center gap-2 sm:gap-4 mb-4">
        {/* Search Input */}
        <div className="flex-1 relative">
          <SearchIcon className="absolute left-4 top-1/2 transform -translate-y-1/2 h-4 w-4 text-slate-400 pointer-events-none" />
          <input
            type="text"
            placeholder="Search models..."
            value={searchValue}
            onChange={(e) => onSearchChange(e.target.value)}
            className="eai-input pl-11"
          />
        </div>

        {/* Sort Dropdown - Icon-only on mobile */}
        <div className="relative">
          <FilterIcon className="sm:hidden absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 h-4 w-4 text-slate-600 pointer-events-none z-10" />
          {/* size="none" and chevron={false}: collapses to a 42px icon button under sm, so it owns its own text sizing and keeps its externally-placed chevron */}
          <Select
            value={sortBy}
            onChange={(e) => onSortChange(e.target.value)}
            aria-label="Sort models"
            size="none"
            chevron={false}
            className="h-[42px] w-[42px] sm:w-auto sm:h-auto sm:pl-4 sm:pr-10 sm:py-2 overflow-hidden text-[0px] sm:text-sm"
            title={sortBy.charAt(0).toUpperCase() + sortBy.slice(1)}
          >
            <option value="recommended">Recommended</option>
            <option value="popular">Popular</option>
            <option value="recent">Recent</option>
            <option value="myModels">My Models</option>
          </Select>
          <ChevronIcon className="hidden sm:block absolute right-4 top-1/2 transform -translate-y-1/2 h-4 w-4 text-slate-400 pointer-events-none" />
        </div>

      </div>

      {/* Tag Filters */}
      <div className="flex flex-wrap gap-2">
          {availableTags.map(tag => (
            <button
              key={tag}
              onClick={() => onTagToggle(tag)}
              className={`eai-chip ${selectedTags.includes(tag) ? 'eai-chip-active' : ''}`}
            >
              {tag}
            </button>
          ))}
      </div>
    </div>
  );
};

export default SearchFilter;